import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const chequeDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "CHEQUEBOOKDETAILS",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.chequeDetails, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chqDepositedByMeDetails = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "CHEQUE",
      // module: "CHEQUEBOOK",
      type: "deposited",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.chqDepositedByMeDetails,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chqIssuedByMeSummary = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      // module: "CHEQUE",
      type: "issued",
      requestId: "CHEQUE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.chqIssuedByMeSummary,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chqDepositedByMeSummary = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      //module: "CHEQUE",
      type: "deposited",
      requestId: "CHEQUE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.chqDepositedByMeSummary,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookChequesStatus = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      //module: "CHEQUEBOOK",
      requestId: "CHEQUE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.chequeBookChequesStatus,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const stopChequeverify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "STOPCHEQUE",
      requestId: "STOPCHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.stopChequeverify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const stopChequeConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "STOPCHEQUE",
      requestId: "STOPCHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.stopChequeConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chqIssuedByMeDetails = async (data) => {
  try {
    const reqParams = {
      module: "CHEQUEBOOK",
      requestId: "CHEQUESTATUS",
      ...data,
    };
    const response = await http.post(
      API_CONFIG.chqIssuedByMeDetails,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const leavesList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CHEQUEBOOK",
      requestId: "CHEQUELEAVES",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.leavesList, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookVerification = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CHEQUEBOOK",
      requestId: "CHEQUEBOOKREQUESTVERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.chequeBookVerification,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeBookConfirmation = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CHEQUEBOOK",
      requestId: "CHEQUEBOOKREQUESTVERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.chequeBookConfirmation,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getStopchequeReasonList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "STOPCHEQUE",
      module: "STOPCHEQUE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getStopchequeReasonList,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const chequeStatusVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "CHQ_STATUS",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.chequeStatusVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};
const chequeStatusConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "CHQ_STATUS",
      module: "CHEQUEBOOK",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.chequeStatusConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};


const ChequeService = {
  chequeDetails,
  chqIssuedByMeSummary,
  chequeBookChequesStatus,
  chqDepositedByMeSummary,
  chqDepositedByMeDetails,
  chqIssuedByMeDetails,
  chequeBookConfirmation,
  chequeBookVerification,
  leavesList,
  stopChequeConfirm,
  stopChequeverify,
  getStopchequeReasonList,
  chequeStatusVerify,
  chequeStatusConfirm,
};

export default ChequeService;
